import styled, { css } from 'styled-components';
import Image from '@components/image';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 3rem;
    width: 100%;

    @media (max-width: ${theme.breakpoints.lg}) {
      row-gap: 2.5rem;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      row-gap: 2.25rem;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      row-gap: 2rem;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1.5rem;
    text-align: center;
    width: 100%;
    max-width: 54rem;
    margin: 0 auto;

    @media (max-width: ${theme.breakpoints.lg}) {
      row-gap: 1.5rem;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      row-gap: 1.25rem;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      text-align: left;
      row-gap: 1rem;
    }
  `}
`;

export const StyledImage = styled(Image)`
  ${({ theme }) => css`
    width: 100%;
    height: auto;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      object-fit: cover;
      min-height: 5rem;
    }
  `}
`;
